import React, { Component } from 'react';

import axios from 'axios';

import swal from 'sweetalert';

import './index.css';

import NumberFormat from 'react-number-format';

import Select from 'react-select';

import apiurl from './apiurl';





export default class Zadanie_Pop extends React.Component {

constructor(props) {

  super(props);



  this.state = {

    errors: null, 

    token: props.token ,

    rok: props.rok ,

    idUchwaly: props.idUchwaly ,

    dzial: props.dzial ,

    rozdzial: props.rozdzial ,

    paragrafP4: props.paragrafP4 ,

    pozycja: props.pozycja ,

    dwbp: props.dwbp ,

    idWydz: props.idWydz ,

    idRodz: props.idRodz ,

    formularzpop: props.formularzpop,

    pokazdodaj: false,

    loadingdata: true,

    onlyExisting: false,

    data4: [],

    savesuccess:false,

    saveload: true,
    uwagiTextArea: '',
  };



  this.timer = this.timer.bind(this);



}



    componentDidMount() {

      this.getData();

    }



    ChangeWniosekpop = (p, idx) => {

      let { data4 } = this.state;

      data4 = data4.map((obj, index) => {

        if (index === idx) {

          obj.wniosek = p.target.value

        }

        return obj;

      });

      this.setState({

        data4

      });

    }

    

    upupdate = (data) => {

      this.props.updatewartosci(data);

    }



    dodajpop = (p) => {

      p.preventDefault();

      axios.post(apiurl+"api/Zadania",

          {rok: this.state.rok, idUchwaly: this.state.idUchwaly, idZadania: this.state.idZadaniadodaj, dzial: this.state.dzial, rozdzial: this.state.rozdzial, paragrafP4: this.state.paragrafP4,

          pozycja: this.state.pozycja, dwbp: this.state.dwbp, idWydz: this.state.idWydz, idRodz: this.state.idRodz, opis: this.state.opis, kwota: this.state.Wniosekd, zrodloFin: this.state.zrodlododaj },

          {headers : {'Content-Type': 'application/json' , 'Authorization' : "Bearer " + this.state.token } })

          .then(res => {

            this.getData();

            this.setState({ formularzpop : true, saveload: true, savesuccess: true });

            setInterval(this.timer, 1000);

            this.getSingledodaj();

          })

      .catch(error => {

        swal(error.response.data)

        this.setState({ saveload: true })});

    }



    getSingledodaj() {

      axios

        .get(apiurl+"api/Budzet/GetSingle", 

        {params : { rok: this.state.rok, idUchwaly: this.state.idUchwaly, idWydz: this.state.idWydz,  DWBP: this.state.dwbp, idRodz: this.state.idRodz, dzial: this.state.dzial, rozdzial: this.state.rozdzial, paragraf: this.state.paragrafP4, },

        headers: { 'Authorization' : "Bearer " + this.props.token}})

        .then(response => {

          this.upupdate(response.data)

        })

        .catch(error => { 

        console.log('errorgetdodaj')

        });

    }





    timer() {

      this.setState({ savesuccess: false, saveload: true });

    }



    getData = () => {

      axios

        .get(apiurl+"api/Zadania?", 

        {params : {rok: this.state.rok, idUchwaly: this.state.idUchwaly, idZadania: this.state.idZadania, dzial: this.state.dzial, rozdzial: this.state.rozdzial, paragraf: this.state.paragrafP4,

        pozycja: this.state.pozycja, DWBP: this.state.dwbp, idWydz: this.state.idWydz, idRodz: this.state.idRodz, opis: this.state.opis, kwota: this.state.kwota},

        headers: { 'Authorization' : "Bearer " + this.state.token }})

        .then(response => {

          this.setState({ data4 : response.data, loadingdata: false });

          let { data4 } = this.state;

          if (data4==''){

            this.setState({ isLoadingpop: false, pobrano: 'tak', pokazdodaj: true });

          }

          else{

            this.setState({ data4, isLoadingpop: true, pobrano: 'tak', pokazdodaj: true, loadingdata : false });

          }

        })

        .catch(error => { 

          // if (error.response.status === 403) {

          //   this.setState({ data4 : error.response.data, loadingdata: false });

          //   let { data4 } = this.state;

          //   if (data4==''){

          //     this.setState({ isLoadingpop: false, pobrano: 'tak', pokazdodaj: false });

          //   }

          //   else{

          //     this.setState({ data4, isLoadingpop: true, pobrano: 'tak', pokazdodaj: false });

          //   }

          // } else { 
            
            swal(error.response.data); 
            this.setState({ pokazdodaj: false }) 
            this.props.closeModal();
          
          // }

        })

    }



    onListaZadania = (exist) => {

      axios

      .get(apiurl+"api/Listy/GetZadania", {params : {rok : this.state.rok, idUchwaly: this.state.idUchwaly, dzial: this.state.dzial, rozdzial: this.state.rozdzial, paragrafp4: this.state.paragrafP4,

        pozycja: this.state.pozycja, dwbp: this.state.dwbp, idWydz: this.state.idWydz, onlyExisting: exist}, headers: { 'Authorization' : "Bearer " + this.state.token }})

      .then(res => {

        let resdata = res.data;

        if(resdata.length > 0 ){

          let data = resdata.map( category => ({ value: category.value, label: category.text}));

          this.setState({data, idZadaniadodaj: data[0].value, Zadaniat: data[0].label});

        } else { this.setState({ data : [] }) }

      })

      .catch(error => swal('error'));

    }



    onListaZrodla = async () => {

      const res = await axios.get(apiurl+"api/Listy/GetZrodlaFin", {  headers: { 'Authorization' : "Bearer " + this.state.token }}).catch(error => this.setState({ error,  }));

      let datafin = res.data.map( category => ({ value: category.value, label: category.text}));

      this.setState({datafin, zrodlododaj: datafin[0].value, zrodlotext: datafin[0].label});

    }



    onChange = (z) => { this.setState({ [z.target.name]: z.target.value }) }

    

setUwagiTrue = (value) => {
  this.setState({ 
    uwagiDoZadaniaForm : true,
    idDzialaniaZad: value.idDzialania,
    idZadaniaZad: value.idZadania,
    wniosekZad: value.wniosek,
  });
  this.getTextZadania(value.idDzialania, value.idZadania);
}  

postUwagiZadanie = (e) => {
  e.preventDefault();
  axios.post(apiurl+"api/UwagiZadan",
  {
    uwagi: this.state.uwagiTextArea,
    rok: this.state.rok,
    idUchwaly: this.state.idUchwaly,
    idWydzialu: this.state.idWydz,
    idRodz: this.state.idRodz,
    dwbp: this.state.dwbp,
    dzial: this.state.dzial,
    rozdzial: this.state.rozdzial,
    paragrafP4: this.state.paragrafP4,
    pozycja: this.state.pozycja,
    idDzialania: this.state.idDzialaniaZad,
    idZadania: this.state.idZadaniaZad,
    wniosek: this.state.wniosekZad,
  },
  {headers : {'Content-Type': 'application/json' , 'Authorization' : "Bearer " + this.state.token } })
  .then(res => {
    this.setState({ uwagiDoZadaniaForm : false })
  })
  .catch(error => {
    swal(error.response.data ? error.response.data : 'Błąd')
  });
}

getTextZadania = (val1, val2) => {
  axios.get(apiurl+"api/UwagiZadan", {params: {
    rok: this.state.rok,
    idUchwaly: this.state.idUchwaly,
    idWydzialu: this.state.idWydz,
    idRodz: this.state.idRodz,
    dwbp: this.state.dwbp,
    dzial: this.state.dzial,
    rozdzial: this.state.rozdzial,
    paragrafP4: this.state.paragrafP4,
    pozycja: this.state.pozycja,
    idDzialania: val1,
    idZadania: val2,
  }, headers: { 'Authorization' : "Bearer " + this.props.token}})
  .then(response => {
    this.setState({ uwagiTextArea: response.data })
  })
  .catch(error => { 
  console.log('Error get text')
  });
}

render() {

const { data, datafin, data4, Zadaniat, zrodlotext, loadingdata, uwagiDoZadaniaForm, uwagiTextArea } = this.state;

return (

<React.Fragment>


{uwagiDoZadaniaForm ? (
  <div className='d-flex flex-column p-4'>
    <h3 className="m-3">Uzasadnienie do zadania</h3>
    <textarea className='form-control' value={uwagiTextArea} onChange={(e) => (this.setState({ uwagiTextArea: e.target.value }))}></textarea>
    <div className='d-flex flex-row mt-2'>
      <button className='btn btn-outline-danger btn-small m-1 ml-auto' onClick={() => (this.setState({ uwagiDoZadaniaForm : false }))}>Zamknij</button>
      <button className='btn btn-outline-success m-1' onClick={(e) => (this.postUwagiZadanie(e))}>Zapisz</button> 
    </div>


  </div>

) : (<>{this.state.formularzpop ? (<>

<div className="">

  <h3 className="m-3">Zadania</h3>

  {this.state.pokazdodaj ? (<button  onClick={() => this.setState({ formularzpop : false}, this.onListaZadania(this.state.onlyExisting), this.onListaZrodla())} type="button" class="btn btn-light ml-3">Dodaj zadanie</button>) : null }

  <hr width="75%" align="left"/>

  {loadingdata ? (<center><div class="spinner-border text-primary" role="status"><span class="sr-only">Loading...</span></div></center>) : null }

  <div class=" card">

  <table  class="table table-hover ">   

  <thead >

    <tr >

      <th scope="col" class="text-center"><b>Działanie</b></th>

      <th scope="col" class="text-center"><b>Zadanie</b></th>

      <th scope="col" class="text-center"><b>Symbol</b></th>

      <th scope="col" class="text-center"><b>Żródło finansowania</b></th>

      <th scope="col" class="text-center"><b>Koszt</b></th>

      <th  width="15%" class="text-center"><b>Wniosek</b></th>
      <th  width="15%" class="text-center"><b>Uwagi</b></th>
      <th  width="15%" class="text-center"><b></b></th>

    </tr>

  </thead>

  <tbody>

    {this.state.isLoadingpop ? (

    data4.map((user4, index) => {

      const { idZadania } = user4;

      return (<React.Fragment key={index}>

        <tr id={idZadania}>

          <ZadanieRow user4={user4} index={index} setUwagiTrue={this.setUwagiTrue} savesuccess={this.state.savesuccess} ChangeWniosekpop={this.ChangeWniosekpop} upupdate={this.upupdate} rok={this.state.rok} idUchwaly={this.state.idUchwaly} dwbp={this.state.dwbp} token={this.state.token} />

        </tr> 

        </React.Fragment>);

        })

        

      ) : ( <tr ><td colSpan="7"><center><p>Brak zadań</p></center></td></tr> ) } </tbody>

      </table></div></div></>) 

      : 

      (<div className="container"> 

      <h3>Dodaj zadanie</h3>

      <hr width="75%" align="left"/>



        <form id="dodaj-zadanie" name="form-dodaj-zadania" class="form-horizontal" onSubmit={(p) => this.dodajpop(p)}> 

            <div class="row">

                  <div class="col-xs-4 col-sm-4 col-md-2 col-lg-2"><label class="control-label">Wybierz działanie:</label></div>

                  <div class="col-xs-6 col-sm-6 col-md-5 col-lg-5">

                  <Select name="form-field-name" options={data} placeholder="Wybierz" onChange={c => this.setState({idZadaniadodaj: c.value})}/>

                  </div>

            </div><br></br>

            <div class="row">

                  <div class="col-xs-4 col-sm-4 col-md-2 col-lg-2"><label class="form-check-label" for="exist">Pokaż istniejące</label></div>

                  <div class="col-xs-6 col-sm-6 col-md-5 col-lg-5">

                  {this.state.onlyExisting ? (<input type="checkbox" class="form-check-input ml-3" checked id="exist" onClick={() => (this.setState({ onlyExisting: false }, this.onListaZadania(false)))}></input>) : (<input type="checkbox" class="form-check-input ml-3" id="exist" onClick={() => (this.setState({ onlyExisting: true }, this.onListaZadania(true)))}></input>)}

                  </div>

            </div><br></br>

            <div class="row">

                <div class="col-xs-4 col-sm-4 col-md-2 col-lg-2"><label class="control-label">Opis:</label></div>

                <div class="col-xs-6 col-sm-6 col-md-5 col-lg-5"><input type="text" class="form-control" id="opis" name="opis" placeholder="Wpisz opis" onChange={(z) => this.onChange(z)}></input></div>

            </div><br></br>

            <div class="row">

                    <div class="col-xs-4 col-sm-4 col-md-2 col-lg-2"><label >Wniosek:</label></div>

                    <div class="col-xs-6 col-sm-6 col-md-5 col-lg-5"><input type="number" class="form-control" required title="Wpisz wniosek" placeholder="0,00" pattern="[0-9]+([\.,][0-9]+)?" step="0.01" id="Wniosekd" name="Wniosekd" onChange={(z) => this.onChange(z)}></input></div>

            </div> <br></br>

            <div class="row">

                  <div class="col-xs-4 col-sm-4 col-md-2 col-lg-2"><label class="control-label">Wybierz źródło finansowania:</label></div>

                  <div class="col-xs-6 col-sm-6 col-md-5 col-lg-5">

                  <Select name="form-field-name" options={datafin} placeholder={zrodlotext} onChange={c => this.setState({zrodlododaj: c.value})}/>

                  </div>

            </div><br></br>

            <div class="row">

                    <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"></div>

                    <div class="col-xs-6 col-sm-6 col-md-5 col-lg-5">

                    <button  onClick={() => this.setState({ formularzpop : true})} type="button" class="btn btn-light pull-left" >Anuluj</button>

                    <button type="submit"  class="btn btn-light m-3" id="function" >Zapisz</button>

                    </div>

            </div>

        </form>

      </div>) }</>) }

</React.Fragment>

      );

    }

  }





export class ZadanieRow extends React.Component {

constructor(props) {

  super();



  this.state = {

    saveload: true, 

    savesuccess: false,

  };



  this.timer = this.timer.bind(this);

}



timer() {

  this.setState({ savesuccess: false, saveload: true });

}







editpop = (user4) => {

  const nowyWp = `${user4.wniosek}`.replace(",", ".");

  axios.put(apiurl+"api/Zadania?",

      {rok: this.props.rok, idUchwaly: this.props.idUchwaly, idWydzialu: `${user4.idWydzialu}`, idRodz: `${user4.idRodz}`,

      dwbp: this.props.dwbp, dzial: `${user4.dzial}`,  rozdzial: `${user4.rozdzial}`, paragrafP4 : `${user4.paragraf}`+`${user4.p4}`, pozycja: `${user4.pozycja}`, idDzialania: `${user4.idDzialania}`, idZadania: `${user4.idZadania}`, wniosek: nowyWp },

      {headers : {'Content-Type': 'application/json' , 'Authorization' : "Bearer " + this.props.token} })

      .then(res => {

      this.getSingle(user4);

      this.setState({ saveload: true, savesuccess: true });

      setInterval(this.timer, 1000);

      })

      .catch(error => {

        swal(error.response.data);

        this.setState({ saveload: true});



      });

}



getSingle(user4) {

  axios

    .get(apiurl+"api/Budzet/GetSingle", 

    {params : { rok: this.props.rok, idUchwaly: this.props.idUchwaly, idWydz: `${user4.idWydzialu}`,  DWBP: this.props.dwbp, idRodz: `${user4.idRodz}`, dzial: `${user4.dzial}`, rozdzial: `${user4.rozdzial}`, paragraf: `${user4.paragraf}`+`${user4.p4}`, },

    headers: { 'Authorization' : "Bearer " + this.props.token}})

    .then(response => {

      this.props.upupdate(response.data)

    })

    .catch(error => { 

    console.log('errorget')

    });

}



render() {

const {  wniosek, idZadania, dzialanie, zadanie, koszt, uchWydzStat, zrodloFin, kod} = this.props.user4;

return(<>

<td ><p>{dzialanie}</p></td>

<td ><p>{zadanie}</p></td>

<td ><p>{kod}</p></td>

<td ><p>{zrodloFin}</p></td>

<td width="15%" class="text-right"><p><NumberFormat value={koszt} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></p></td>

<td width="15%" class="text-right">

{uchWydzStat === true ?(

<NumberFormat value={wniosek} class="form-control" onChange={(p) => this.props.ChangeWniosekpop(p, this.props.index)} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','}/>

) :(<NumberFormat value={wniosek} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} />       )

}

</td>

<td width="7%" class="text-center d-flex flex-row">
<button type="button" class="btn btn-light btn-sm mr-1" onClick={() => (this.props.setUwagiTrue(this.props.user4))}>Uzasadnienie</button>

{uchWydzStat === true ?(<>

{this.state.savesuccess ? (<button  type="button" class="btn btn-light" disabled><i class="fa fa-check"></i></button>) : (<>{this.state.saveload ? (<button type="button" onClick={() => (this.setState({ saveload: false}, this.editpop(this.props.user4)))} class="btn btn-light btn-sm">Zapisz</button>) : (<button  type="button" class="btn btn-light" disabled><div class="spinner-border text-primary spinner-border-sm" role="status"></div></button>)} </>)}

</>) : ( null )

}

</td>



</>)}





}

